export const ARTICLE_INFO_TYPE = {
  TITLE: "title",
  COMMON: "common",
};

export const ARTICLE_INFO_TYPE_CLASS = {
  [ARTICLE_INFO_TYPE.COMMON]: "common",
  [ARTICLE_INFO_TYPE.TITLE]: "",
};

export const INFO_ITEM_TYPE = {
  AUTHOR: "author",
  READING_TIME_DESKTOP: "desktop",
  READING_TIME_MOBILE: "mobile",
  PUBLISHED_DATE: "published-date",
};
